import { faIdCard } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ContactCardPropsType = {
  mode: 'create' | 'open';
  onClick: () => void;
  disabled: boolean;
};

export const ContactCard: React.FC<ContactCardPropsType> = ({
  mode,
  onClick,
  disabled,
}) => {
  const { t } = useTranslation('personDetailsGeneral');

  return (
    <ActionIcon
      color="blue"
      variant={mode === 'open' ? 'filled' : 'outline'}
      onClick={onClick}
      disabled={disabled}
      data-testid="contact-card-action-icon"
      role="button"
      aria-label={t('COMPANY_LINKS.CONTACT_CARD.ACTION_LABEL')}
    >
      <FontAwesomeIcon icon={faIdCard} />
    </ActionIcon>
  );
};
